import { apiFetch } from "./CommonApi";
import { notify } from "../Components/Common";


const interactiveTypes = ["media_card_carousel","product_card_carousel","multi_product_message"];

function appendInteractiveFields(formData, data) {
  if (!interactiveTypes.includes(data.template_type)) return;

  // commerce_catalog_id for product/multi-product
  if (data.commerce_catalog_id) formData.append("commerce_catalog_id", data.commerce_catalog_id);

  // Cards: send per-index file and sanitized JSON without File objects
  const cards = Array.isArray(data.cards) ? data.cards : [];
  cards.forEach((c, i) => {
    if (c.image_file) {
      formData.append(`cards.${i}.image_file`, c.image_file);
    }
  });
  const jsonCards = cards.map(({ image_file, ...rest }) => rest);
  formData.append("cards", JSON.stringify(jsonCards));

  // Product sections
  const sections = Array.isArray(data.product_sections) ? data.product_sections : [];
  if (sections.length) {
    formData.append("product_sections", JSON.stringify(sections));
  }
}

export const loadTemplates = (param) => {
  const url = param
    ? `whatsapp-business/templates/?${param}`
    : "whatsapp-business/templates/?page=1";

  return apiFetch("GET", url, null, true).then((res) => {
    if (res.ok) {
      return res.json();
    }
  });
};
export const loadSpecificTemplate = (templateId) => {
  return apiFetch(
    "GET",
    `whatsapp-business/templates/${templateId}/`,
    null,
    true
  ).then((res) => {
    if (res.ok) {
      return res.json();
    }
  });
};

export const delTemplate = (templateId) => {
  return apiFetch(
    "DELETE",
    `whatsapp-business/templates/${templateId}/`,
    null,
    true
  ).then((res) => {
    if (res.ok) {
      return true;
    }
  });
};

export const createTemplateReview = (data, selectedMedia, buttonData) => {
  const formData = new FormData();

  // normalize "custom" to backend choice "template"
  const normalizedType = data.template_type === "custom" ? "template" : data.template_type;
  if (normalizedType) formData.append("template_type", normalizedType);

  // buttons
  buttonData?.forEach((button, index) => {
    Object.entries(button).forEach(([key, value]) => {
      formData.append(`buttons.${index}.${key}`, value);
    });
  });

  // interactive extras first
  appendInteractiveFields(formData, { ...data, template_type: normalizedType });

  // simple fields
  Object.entries(data).forEach(([key, value]) => {
    if (
      ["file", "fileName", "cards", "product_sections"].includes(key)
    ) return;
    if (key === "category") {
      if (value?.value) formData.append("category", value.value);
      return;
    }
  if (key === "header_content_text" && data.header_content_type === "media") return;
    if (key === "header_content_type") {
      formData.append(key, value === "none" ? "" : value);
      return;
    }
    if (value !== undefined && value !== null) formData.append(key, value);
  });

  // dataURL media
  if (data.file) {
    return fetch(data.file)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], data.fileName || "upload");
        if (selectedMedia === "image") formData.append("header_content_image", file);
        if (selectedMedia === "document") formData.append("header_content_document", file);
        if (selectedMedia === "video") formData.append("header_content_video", file);
        if (data.fileName) formData.append("header_fileName", data.fileName);
        console.log("formData before submit with file:", formData);
        return apiFetch("POST", "whatsapp-business/templates/", formData, true)
          .then((res) => res?.json())
          .then((res) => {
            if (res?.id) {
              templateStatus({ template_id: res.id, status: "in_review" });
            }
          });
      });
  }


  console.log("formData before submit:", formData);
  return apiFetch("POST", "whatsapp-business/templates/", formData, true)
    .then((res) => {
      if (!res.ok) throw new Error("Failed to create template draft");
      return res.json();
    })
    .then((res) => {
      if (res?.id) templateStatus({ template_id: res.id, status: "in_review" });
      return res;
    });
};

export const templateStatus = (body) => {
  return apiFetch(
    "POST",
    "whatsapp-business/template/status/",
    body,
    true
  ).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      throw new Error("Failed to update template status");
    }
  });
};

export const createTemplateDraft = (data, selectedMedia, buttonData) => {
  const formData = new FormData();

  const normalizedType = data.template_type === "custom" ? "template" : data.template_type;
  if (normalizedType) formData.append("template_type", normalizedType);

  buttonData?.forEach((button, index) => {
    Object.entries(button).forEach(([key, value]) => {
      formData.append(`buttons.${index}.${key}`, value);
    });
  });
  appendInteractiveFields(formData, { ...data, template_type: normalizedType });

  Object.entries(data).forEach(([key, value]) => {
    if (["file", "fileName", "cards", "product_sections"].includes(key)) return;
    if (key === "category") {
      if (value?.value) formData.append("category", value.value);
      return;
    }
    if (key === "header_content_text" && data.header_content_type === "media") return;
    if (key === "header_content_type") {
      formData.append(key, value === "none" ? "" : value);
      return;
    }
    if (value !== undefined && value !== null) formData.append(key, value);
  });

  if (data.file) {
    return fetch(data.file)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], data.fileName || "upload");
        if (selectedMedia === "image") formData.append("header_content_image", file);
        if (selectedMedia === "document") formData.append("header_content_document", file);
        if (selectedMedia === "video") formData.append("header_content_video", file);
        if (data.fileName) formData.append("header_fileName", data.fileName);
        console.log("formData before submit with file:", formData);
        return apiFetch("POST", "whatsapp-business/templates/", formData, true)
          .then((res) => {
            if (!res.ok) throw new Error("Failed to create template draft");
            return res.json();
          });
      });
  }

  console.log("formData before submit:", formData);
  return apiFetch("POST", "whatsapp-business/templates/", formData, true).then((res) => {
    if (!res.ok) throw new Error("Failed to create template draft");
    return res.json();
  });
};

export const templateEditDraft = (templateId, data, selectedMedia, buttonData) => {
  const formData = new FormData();

  const normalizedType = data.template_type === "custom" ? "template" : data.template_type;
  if (normalizedType) formData.append("template_type", normalizedType);

  buttonData?.forEach((button, index) => {
    Object.entries(button).forEach(([key, value]) => {
      formData.append(`buttons.${index}.${key}`, value);
    });
  });

  appendInteractiveFields(formData, { ...data, template_type: normalizedType });

  Object.entries(data).forEach(([key, value]) => {
    if (["file", "fileName", "body_example", "header_example", "cards", "product_sections"].includes(key)) return;
    if (key === "category") {
      if (value?.value) formData.append("category", value.value);
      return;
    }
    if (key === "header_content_text" && data.header_content_type === "media") return;
    if (key === "header_content_type") {
      formData.append(key, value === "none" ? "" : value);
      return;
    }
    if (value !== undefined && value !== null) formData.append(key, value);
  });

  if (Array.isArray(data.body_example)) {
    formData.append("body_example", data.body_example.join(","));
  } else if (typeof data.body_example === "string") {
    formData.append("body_example", data.body_example);
  }
  if (Array.isArray(data.header_example)) {
    formData.append("header_example", data.header_example.join(","));
  } else if (typeof data.header_example === "string") {
    formData.append("header_example", data.header_example);
  }

  const uploadAndPut = () =>
    apiFetch("PUT", `whatsapp-business/templates/${templateId}/`, formData, true).then((res) => {
      if (!res.ok) throw new Error("Failed to update template");
      templateStatus({ template_id: templateId, status: "draft" });
      return res;
    });

  if (data.file) {
    return fetch(data.file)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], data.fileName || "upload");
        if (selectedMedia === "image") formData.append("header_content_image", file);
        if (selectedMedia === "document") formData.append("header_content_document", file);
        if (selectedMedia === "video") formData.append("header_content_video", file);
        if (data.fileName) formData.append("header_fileName", data.fileName);
        return uploadAndPut();
      });
  }

  return uploadAndPut();
};
export const editTemplateReview = (
  templateId,
  data,
  selectedMedia,
  buttonData
) => {
  // console.log(data);
  const formData = new FormData();
  buttonData?.forEach((button, index) => {
    Object.entries(button).forEach(([key, value]) => {
      formData.append(`buttons.${index}.${key}`, value);
    });
  });

  appendInteractiveFields(formData, data);

  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (
        key === "file" ||
        key === "fileName" ||
        key === "body_example" ||
        key === "header_example" ||
        key === "cards" ||
        key === "product_sections"
      ) {
        continue;
      } else {
        formData.append(key, value);
      }
    }
  }

  if ("body_example" in data && data.body_example) {
    const bodyExample =
      typeof data.body_example === "string"
        ? data.body_example
        : data.body_example.join(",");
    bodyExample && formData.append(`body_example`, bodyExample);
  }

  if ("header_example" in data && data.header_example) {
    const headreExample =
      typeof data.header_example === "string"
        ? data?.header_example
        : data?.header_example.join(",");
    headreExample && formData.append(`header_example`, headreExample);
  }

  if ("file" in data && data.file) {
    return fetch(data.file)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], data.fileName);
        if (selectedMedia === "image") {
          formData.append("header_content_image", file);
        }
        if (selectedMedia === "document") {
          formData.append("header_content_document", file);
        }
        if (selectedMedia === "video") {
          formData.append("header_content_video", file);
        }
        formData.append("header_fileName", data?.fileName);
        return apiFetch(
          "PUT",
          `whatsapp-business/templates/${templateId}/`,
          formData,
          true
        ).then((res) => {
          if (res.ok) {
            if (templateId) {
              templateStatus({
                template_id: templateId,
                status: "in_review",
              });
            }
            return res;
          } else {
            // console.log(res.json());
            throw new Error("Failed to create template draft");
          }
        });
      });
  }

  return apiFetch(
    "PUT",
    `whatsapp-business/templates/${templateId}/`,
    formData,
    true
  ).then((res) => {
    if (res.ok) {
      if (templateId) {
        templateStatus({
          template_id: templateId,
          status: "in_review",
        });
      }
      return res;
    } else {
      throw new Error("Failed to update template");
    }
  });
};

export const templatePreview = (body) => {
  return apiFetch(
    "POST",
    "whatsapp-business/template/preview/",
    body,
    true
  ).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      console.log(res);
      throw new Error("Failed to get template preview");
    }
  });
};

export const getTemplateTags = (param) => {
  const url = `whatsapp-business/template-tags/?text=${param}`;

  return apiFetch("GET", url, null, true).then((res) => {
    if (res.ok) {
      return res.json();
    }
  });
};

export const sendReview = (templateId) => {
  const url = `whatsapp-business/templates/${templateId}/send-to-review/`;

  return apiFetch("POST", url, null, true).then((res) => {
    if (res.ok) {
      return res.json();
    }
  });
};




export async function fetchCatalogs(business, appToken) {
  if (!business) return [];
  const qs = new URLSearchParams({ appToken }).toString();
  const url = `whatsapp-business/catalogs/${business}?${qs}`;
  const res = await apiFetch("GET", url, null, true); // returns Response
  const data = await res.json();                      // parse JSON
  console.log("Catalogs response:", data);
  return data?.data || [];
}

export async function fetchProducts(catalogId, appToken) {
  if (!catalogId) return [];
  const qs = new URLSearchParams({ appToken }).toString();
  const url = `whatsapp-business/catalogs/${catalogId}/products?${qs}`;
  const res = await apiFetch("GET", url, null, true);
  const data = await res.json();   // parse the body
  console.log("Products response:", data);
  return data?.data || [];
}